module.exports = __webpack_public_path__ + "img/Weapon_202.27cebb9d.png";